(function () {
  var STORAGE_KEY = "skei_active_ad_promo";
  var DAYS_TO_KEEP = 7;
  var CACHE_BUSTER = "v7";

  function now() {
    return new Date().getTime();
  }

  function getExpiryTimestamp() {
    return now() + DAYS_TO_KEEP * 24 * 60 * 60 * 1000;
  }

  function getUrlParam(name) {
    var params = new URLSearchParams(window.location.search);
    return params.get(name);
  }

  function getConfig() {
    var raw = window.SKEI_AD_PROMOS || {};

    return {
      promos: raw.promos || {},
      adIdMap: raw.adIdMap || {}
    };
  }

  function getPromoByPromoId(promoId) {
    var config = getConfig();

    if (!promoId || !config.promos[promoId]) {
      return null;
    }

    return {
      promo_id: promoId,
      promo: config.promos[promoId]
    };
  }

  function getPromoByAdId(adId) {
    var config = getConfig();

    if (!adId || !config.adIdMap) {
      return null;
    }

    var matchedPromoId = null;

    Object.keys(config.adIdMap).some(function (promoId) {
      var adIds = config.adIdMap[promoId];

      if (typeof adIds === "string") {
        adIds = adIds.split(",").map(function (item) {
          return item.trim();
        });
      }

      if (!Array.isArray(adIds)) {
        return false;
      }

      if (adIds.indexOf(adId) !== -1) {
        matchedPromoId = promoId;
        return true;
      }

      return false;
    });

    if (!matchedPromoId) {
      return null;
    }

    return getPromoByPromoId(matchedPromoId);
  }

  function savePromo(promoId, sourceKey, sourceValue, promo) {
    if (!promoId || !promo || !promo.products || !promo.products.length) return;

    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          promo_id: promoId,
          source_key: sourceKey || "",
          source_value: sourceValue || "",
          name: promo.name || "",
          products: promo.products,
          expires_at: getExpiryTimestamp()
        })
      );
    } catch (e) {}
  }

  function getSavedPromo() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;

      var promo = JSON.parse(raw);

      if (!promo.expires_at || promo.expires_at < now()) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }

      if (!promo.products || !promo.products.length) return null;

      return promo;
    } catch (e) {
      return null;
    }
  }

  function capturePromoFromUrl() {
    var directPromoId = getUrlParam("skei_promo");
    var adId = getUrlParam("ad_id");

    if (directPromoId) {
      var directMatch = getPromoByPromoId(directPromoId);

      if (directMatch) {
        savePromo(
          directMatch.promo_id,
          "skei_promo",
          directPromoId,
          directMatch.promo
        );
        return;
      }
    }

    if (adId) {
      var adMatch = getPromoByAdId(adId);

      if (adMatch) {
        savePromo(
          adMatch.promo_id,
          "ad_id",
          adId,
          adMatch.promo
        );
        return;
      }
    }
  }

  function uniqueArray(items) {
    var seen = {};
    var result = [];

    items.forEach(function (item) {
      if (!item || seen[item]) return;
      seen[item] = true;
      result.push(item);
    });

    return result;
  }

  function productItemToHandle(item) {
    if (!item) return null;
    if (typeof item === "string") return item;
    if (item.handle) return item.handle;
    return null;
  }

  function getPromoHandles(promo) {
    return uniqueArray(
      (promo.products || [])
        .map(productItemToHandle)
        .filter(Boolean)
    );
  }

  function getRootUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    return "/";
  }

  function makeUniqueId() {
    return Date.now() + "-" + Math.random().toString(36).slice(2, 10);
  }

  function fetchProductCard(handle) {
    return fetch(
      getRootUrl() +
        "products/" +
        encodeURIComponent(handle) +
        "?view=skei-promo-card&v=" +
        CACHE_BUSTER,
      {
        credentials: "same-origin"
      }
    )
      .then(function (response) {
        if (!response.ok) throw new Error("Product card not found: " + handle);
        return response.text();
      })
      .then(function (html) {
        html = html.trim();

        if (!html || html.indexOf("product-item") === -1) {
          throw new Error("Invalid product card HTML: " + handle);
        }

        return html.replaceAll("UNIQUE_ID", makeUniqueId());
      });
  }

  function sliderOptionsHtml(productsCount) {
    return JSON.stringify({
      selector: ".product-item",
      groupCells: true,
      navigationDOM:
        '<span class="css-slider-button css-slider-prev" style="display:none"><svg fill="none" height="11" viewBox="0 0 6 11" width="6" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m4.32845 10.0708-4.18198-4.18194c-.195261-.19526-.195261-.51185 0-.70711l4.18198-4.181979c.19527-.195262.51185-.195262.70711 0 .19526.195259.19526.511849 0 .707109l-3.32843 3.32842s-.70713.4647-.00002 1l3.32845 3.32843c.19526.19526.19526.51185 0 .70707-.19526.1953-.51185.1953-.70711 0z" fill="#000" fill-rule="evenodd"/></svg></span><span class="css-slider-button css-slider-next" style="display:none"><svg fill="none" height="11" viewBox="0 0 6 11" width="6" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m.853555.999962 4.181985 4.181978c.19526.19526.19526.51185 0 .70711l-4.181983 4.18195c-.195263.1953-.511845.1953-.707108 0-.1952631-.19523-.1952632-.51181 0-.70708l3.328431-3.32842s.70713-.4647.00002-1l-3.328453-3.32843c-.1952626-.19526-.1952627-.51185 0-.707108.195263-.195262.511845-.195262.707108 0z" fill="#000" fill-rule="evenodd"/></svg></span>',
      thumbnailsDOM:
        '<div class="css-slider-dot-navigation" style="display:none;--size:' +
        productsCount +
        '"></div>'
    }).replace(/"/g, "&quot;");
  }

  function buildSliderHtml(cardsHtml, section) {
    var layout = section.getAttribute("data-skei-promo-layout") || "grid-4 grid-portable-3 grid-lap-2";
    var mobileLayout = section.getAttribute("data-skei-promo-layout-mobile") || "grid-palm-2";

    return [
      '<css-slider',
      ' data-options="' + sliderOptionsHtml(cardsHtml.length) + '"',
      ' class="css-slider css-slider--bottom-navigation"',
      '>',
      '<div class="grid grid--slider ' + layout + " " + mobileLayout + '">',
      cardsHtml.join(""),
      "</div>",
      "</css-slider>"
    ].join("");
  }

  function wakeLazyImages(section) {
    section.querySelectorAll(".lazy-image img").forEach(function (img) {
      var figure = img.closest(".lazy-image");
      if (!figure) return;

      if (img.complete) {
        figure.classList.add("lazyloaded");
        figure.classList.add("lazy-image--revealed");
      }
    });
  }

  function initializePromoQuickBuyFallback(root) {
    if (!root) return;

    root.querySelectorAll("[data-js-product-item]").forEach(function (card) {
      if (card.getAttribute("data-skei-quick-buy-fallback-ready") === "true") return;

      card.setAttribute("data-skei-quick-buy-fallback-ready", "true");

      var variants = card.querySelector("product-variants");
      var form = card.querySelector("form");
      var hiddenInput = form ? form.querySelector('input[name="id"]') : null;
      var button = card.querySelector("[data-js-product-add-to-cart]");
      var buttonText = card.querySelector("[data-js-product-add-to-cart-text]");

      if (!variants || !form || !hiddenInput || !button || !buttonText) return;

      function getAddToCartText() {
        if (
          window.KROWN &&
          KROWN.settings &&
          KROWN.settings.locales &&
          KROWN.settings.locales.products_add_to_cart_button
        ) {
          return KROWN.settings.locales.products_add_to_cart_button;
        }

        return "In den Warenkorb";
      }

      function getSoldOutText() {
        if (
          window.KROWN &&
          KROWN.settings &&
          KROWN.settings.locales &&
          KROWN.settings.locales.products_sold_out_variant
        ) {
          return KROWN.settings.locales.products_sold_out_variant;
        }

        return "Ausverkauft";
      }

      function getVariantRequiredText() {
        if (
          window.KROWN &&
          KROWN.settings &&
          KROWN.settings.locales &&
          KROWN.settings.locales.products_variant_required
        ) {
          return KROWN.settings.locales.products_variant_required;
        }

        return "Zuerst Größe wählen";
      }

      function getAllVariantInputs() {
        return Array.prototype.slice.call(
          variants.querySelectorAll('input[type="radio"][data-variant-id]')
        );
      }

      function hasAnyAvailableVariant() {
        return getAllVariantInputs().some(function (input) {
          return input.getAttribute("data-available") === "true";
        });
      }

      function getSelectedInput() {
        return (
          variants.querySelector('input[type="radio"]:checked') ||
          variants.querySelector('input[type="radio"][data-selected]')
        );
      }

      function setButtonEnabled(variantId) {
        hiddenInput.value = variantId;

        button.classList.remove("disabled");
        form.classList.remove("disabled-cart");
        form.classList.remove("unavailable-variant");

        buttonText.textContent = getAddToCartText();
      }

      function setButtonDisabledRequired() {
        button.classList.add("disabled");
        form.classList.add("disabled-cart");
        form.classList.add("unavailable-variant");

        buttonText.innerHTML =
          getAddToCartText() +
          '<br><span class="button__subtext">(' +
          getVariantRequiredText() +
          ")</span>";
      }

      function setButtonSoldOut() {
        button.classList.add("disabled");
        form.classList.add("disabled-cart");
        form.classList.add("unavailable-variant");

        buttonText.textContent = getSoldOutText();
      }

      function updateFromSelection() {
        if (!hasAnyAvailableVariant()) {
          setButtonSoldOut();
          return;
        }

        var selectedInput = getSelectedInput();

        if (!selectedInput) {
          setButtonDisabledRequired();
          return;
        }

        var variantId = selectedInput.getAttribute("data-variant-id");
        var available = selectedInput.getAttribute("data-available");

        if (!variantId) {
          setButtonDisabledRequired();
          return;
        }

        if (available === "false") {
          setButtonSoldOut();
          return;
        }

        setButtonEnabled(variantId);
      }

      variants.addEventListener("change", function (event) {
        var target = event.target;

        if (!target || !target.matches('input[type="radio"]')) return;

        variants.querySelectorAll('input[type="radio"]').forEach(function (input) {
          input.removeAttribute("data-selected");
          input.removeAttribute("checked");
        });

        target.setAttribute("data-selected", "");
        target.setAttribute("checked", "checked");

        updateFromSelection();
      });

      variants.addEventListener("click", function (event) {
        var input = event.target.closest('input[type="radio"]');

        if (!input) return;

        window.setTimeout(function () {
          input.checked = true;
          input.setAttribute("data-selected", "");
          updateFromSelection();
        }, 0);
      });

      form.addEventListener(
        "submit",
        function (event) {
          updateFromSelection();

          if (button.classList.contains("disabled")) {
            event.preventDefault();
            event.stopPropagation();
            return false;
          }
        },
        true
      );

      updateFromSelection();
    });
  }

  function resetSlider(section) {
    var slider = section.querySelector("css-slider");

    if (!slider) return;

    window.setTimeout(function () {
      if (typeof slider.resetSlider === "function") {
        slider.resetSlider(true, true);
      }

      window.dispatchEvent(new Event("resize"));
    }, 150);
  }

  function resetPromoVariantSliders(section) {
    if (!section) return;

    window.setTimeout(function () {
      section.querySelectorAll("[data-js-product-item] quick-buy css-slider").forEach(function (slider) {
        if (typeof slider.resetSlider === "function") {
          slider.resetSlider(false, false);
        }
      });
    }, 150);
  }

  function renderSection(section, promo) {
    var target = section.querySelector("[data-skei-promo-slider-target]");
    var limit = parseInt(section.getAttribute("data-skei-promo-products-limit") || "8", 10);
    var handles = getPromoHandles(promo).slice(0, limit);

    if (!target || !handles.length) {
      section.style.display = "none";
      return;
    }

    section.style.display = "none";
    target.innerHTML = "";

    Promise.all(
      handles.map(function (handle) {
        return fetchProductCard(handle).catch(function () {
          return null;
        });
      })
    ).then(function (cardsHtml) {
      cardsHtml = cardsHtml.filter(function (html) {
        return html && html.indexOf("product-item") !== -1;
      });

      if (!cardsHtml.length) {
        section.style.display = "none";
        return;
      }

      target.innerHTML = buildSliderHtml(cardsHtml, section);
      section.style.display = "";

      wakeLazyImages(section);
      initializePromoQuickBuyFallback(section);
      resetSlider(section);
      resetPromoVariantSliders(section);
    });
  }

  function init() {
    capturePromoFromUrl();

    var promo = getSavedPromo();
    var sections = document.querySelectorAll("[data-skei-promo-featured-products]");

    if (!sections.length) return;

    if (!promo) {
      sections.forEach(function (section) {
        section.style.display = "none";
      });
      return;
    }

    sections.forEach(function (section) {
      renderSection(section, promo);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", function () {
    init();
  });
})();